const news = [
  {
    date: '2026.05.15',
    category: '보도자료',
    title: '에너버즈, 스마트그리드 AI 솔루션 특허 출원',
    desc: '자사 AI 기술을 활용한 스마트그리드 최적화 알고리즘 관련 특허를 국내 출원했습니다.',
  },
  {
    date: '2026.04.10',
    category: '공지사항',
    title: '2026년 상반기 에너지 플랫폼 업데이트 안내',
    desc: 'Digital Twin 및 분산에너지 네트워크 모듈의 기능이 대폭 강화되었습니다.',
  },
  {
    date: '2026.03.22',
    category: '보도자료',
    title: '에너버즈, 정부 에너지 효율화 과제 수주',
    desc: '산업통상자원부 주관 에너지 효율화 혁신 기술 개발 과제에 선정되었습니다.',
  },
];

export default function NewsSection() {
  return (
    <section id="news" className="relative py-24 md:py-32 bg-enerverze-bg">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="mb-12">
          <p className="text-sm text-enerverze-subtle mb-3">Newsroom</p>
          <h2 className="text-3xl md:text-5xl font-bold text-enerverze-text leading-tight">
            최신 <span className="text-neon-cyan">소식</span>
          </h2>
        </div>

        <div className="space-y-4">
          {news.map((item, idx) => (
            <div
              key={idx}
              className="group flex flex-col md:flex-row md:items-center gap-4 md:gap-8 p-6 rounded-2xl bg-enerverze-card border border-enerverze-border hover:border-neon-cyan transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0">
                <span className="inline-block px-3 py-1 rounded-full text-xs text-neon-cyan border border-neon-cyan/30 bg-neon-cyan/10">
                  {item.category}
                </span>
              </div>
              <div className="flex-grow">
                <h3 className="text-base md:text-lg font-semibold text-enerverze-text mb-1 group-hover:text-neon-cyan transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-enerverze-muted">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-sm text-enerverze-subtle">
                {item.date}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}